import React, { useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Modal, Image } from 'react-bootstrap';
import CloseIcon from '../../assets/images/prompt_close_icon.svg';
import PromptButton, { BUTTON_TYPES } from 'components/base/prompt/BaseButtons';
import { PermissionCodes } from 'config/PermissionCodes';
import CustomerFilterableDropdown from 'components/transactions/CustomerFilterableDropdown';
import { CustomTitleWithRadio } from 'components/earning/CustomBaseComponments';
import { CUSTOMER_REFERRER_METHOD, DISPLAY_CUSTOMER_REFERRER_METHOD, EarningRuleType } from 'config/CustomEnums';
import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import { createAction } from 'utils';


const EditMembershipModal = ({
  customer,
  earningRuleList,
  show,
  setShow,
}) => {
  const dispatch = useDispatch();
  const [referralMethod, setReferralMethod] = useState(customer?.referralSource?.referralMethod || CUSTOMER_REFERRER_METHOD.REFERRAL_CODE)
  const [referral, setReferral] = useState(customer.referrerUser);
  const [promotionCodeEarningRule, setPromotionCodeEarningRule] = useState(customer?.referralSource?.referralEarningRules?.length === 1 ? {
    label: customer?.referralSource?.referralEarningRules[0]?.displayEarningRule,
    value: customer?.referralSource?.referralEarningRules[0]
  } : {})

  const displayPromotionCode = useMemo(() => {
    if ("value" in promotionCodeEarningRule) {
      return promotionCodeEarningRule.value?.newMemberTypePromotionCode
    }
    if (customer?.referralSource?.referralEarningRules?.length > 1) {
      return customer?.referralSource?.referralEarningRules[0]?.newMemberTypePromotionCode
    }
    return
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promotionCodeEarningRule])

  const onClose = () => {
    setShow(false);
  };

  const saveAction = () => {
    let customerReferralInfo = {}
    if (referralMethod === CUSTOMER_REFERRER_METHOD.REFERRAL_CODE) {
      customerReferralInfo = {
        referrerUser: referral,
        referralEarningRules: [],
      }
    } else if (referralMethod === CUSTOMER_REFERRER_METHOD.PROMOTION_CODE) {
      customerReferralInfo = {
        referrerUser: null,
        referralEarningRules: promotionCodeEarningRule?.value?.pk ? [promotionCodeEarningRule] : []
      }
    }
    dispatch(createAction("customerList/updateCustomer")({
      data: {
        ...customer,
        ...customerReferralInfo
      },
      customer: customer,
      refreshCustomer: true,
    }))
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop='static'
    >
      <Modal.Body className={`base-prompt-container customer-detail-prompt`}>
        <Image
          src={CloseIcon}
          className="base-prompt-close-button customer-detail-prompt-close-button"
          onClick={onClose}
        />

        <label className='customer-detail-modal-title'>{"Edit membership"}</label>
        <CustomTitleWithRadio
          title={"Referrer method (optional)"}
          options={[CUSTOMER_REFERRER_METHOD.REFERRAL_CODE, CUSTOMER_REFERRER_METHOD.PROMOTION_CODE].map(item => ({
            label: DISPLAY_CUSTOMER_REFERRER_METHOD?.[item] || item,
            value: item,
          }))}
          defaultValue={referralMethod || CUSTOMER_REFERRER_METHOD.REFERRAL_CODE}
          setValue={(value) => {
            setReferralMethod(value)
          }}
        />
        {referralMethod === CUSTOMER_REFERRER_METHOD.REFERRAL_CODE &&
          <CustomerFilterableDropdown
            title={'Referral code (Membership ID)'}
            description='Changes will not trigger any referral earning logic, it is for record purpose only.'
            defaultSelectedCustomer={referral}
            selectCustomer={(value) => {
              setReferral(value);
            }}
          />
        }
        {referralMethod === CUSTOMER_REFERRER_METHOD.PROMOTION_CODE &&
          <>
            <CustomTitleWithDropDown
              title={"Promotion code"}
              description={"Changes will not trigger any referral earning logic, it is for record purpose only."}
              defaultValue={promotionCodeEarningRule}
              setValue={setPromotionCodeEarningRule}
              source={earningRuleList}
              labelContainPk
              loadMoreAction={'earningRuleList/getEarningRuleListWithTypes'}
              filterAction={'earningRuleList/getEarningRuleListWithTypes'}
              defaultFilter={{
                otherSearch: {
                  requirePromotionCode: true,
                  typeIn: [
                    EarningRuleType.newMember,
                  ],
                }
              }}
            />
            <label>{`Promotion code: ${displayPromotionCode || "-"}`}</label>
          </>
        }


        <div className="base-prompt-buttons customer-detail-prompt-buttons">
          <PromptButton
            title='Cancel'
            action={onClose}
            type={BUTTON_TYPES.secondary}
          />
          <PromptButton
            title='Confirm'
            action={saveAction}
            requires={PermissionCodes.changeCustomer}
            type={BUTTON_TYPES.main}
          />
        </div>

      </Modal.Body>
    </Modal>
  );
}

const mapPropsToState = (state) => ({
  customer: state.customerList.customer,
  earningRuleList: state.earningRuleList.earningRuleList,
});

export default connect(mapPropsToState)(EditMembershipModal);
